import axios from "axios"

import { logout, normalizeStoragePayload } from "utils"
import { store } from "@redux"
import router from "routes/index.routes"
import { refreshAccessToken } from "./accountService"

const API_AUTH_URL =
  process.env.REACT_APP_API_AUTH_URL

const API_MAIN_URL =
  process.env.REACT_APP_API_MAIN_URL
  
const API_SUBSCRIBE_URL =
  process.env.REACT_APP_API_SUBSCRIBE_URL

const API_ANALYTIC_URL =
  process.env.REACT_APP_API_ANALYTIC_URL

const API_STORAGE_URL =
  process.env.REACT_APP_API_STORAGE_URL

let isRefreshing = false
let failedQueue = []
let isRedirectingToSignin = false

const handleRequest = req => {
  try {
    if (localStorage.at) {
      req.headers.common["X-Access-Token"] =
        `Bearer ${localStorage.at}`
    }
  } catch (err) {
    console.log(err)
  }

  req.headers.common["X-Service-Client-Name"] =
    store.getState().systemSettings.clientName

  return req
}

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    error
      ? prom.reject(error)
      : prom.resolve(token)
  })
  failedQueue = []
}

const waitingForToken = () => (
  new Promise((resolve, reject) => {
    failedQueue.push({ resolve, reject })
  })
)

const isRefreshTokenRequest = request => (
  request?.url?.includes("/account/refresh/token")
)

const hasStoredToken = () => (
  !!localStorage.getItem("at") || !!localStorage.getItem("rt")
)

const redirectToSignin = () => {
  if (!hasStoredToken()) return

  logout({ notifyServer: false })

  if (isRedirectingToSignin) return

  isRedirectingToSignin = true

  const navigation =
    router.navigate("/", { replace: true })

  if (navigation?.finally) {
    navigation.finally(() => {
      isRedirectingToSignin = false
    })
  } else {
    isRedirectingToSignin = false
  }
}

const handleError = async (error, api) => {
  if (!error.response) return Promise.reject(error)

  const { status } = error.response
  const originalRequest = error.config || error.response.config

  if (isRefreshTokenRequest(originalRequest)) {
    return Promise.reject(error)
  }

  if ([401, 403].includes(status) && !originalRequest._retry) {
    if (!localStorage.getItem("rt")) {
      redirectToSignin()

      return Promise.reject(error)
    }

    if (isRefreshing) {
      try {
        const accessToken = await waitingForToken()

        originalRequest.headers["X-Access-Token"] = `Bearer ${accessToken}`

        return api(originalRequest)
      } catch (err) {
        return Promise.reject(err)
      }
    }

    originalRequest._retry = true

    isRefreshing = true

    try {
      const { accessToken, refreshToken } =
        await refreshAccessToken()

      localStorage.setItem("at", accessToken)

      localStorage.setItem("rt", refreshToken)

      originalRequest.headers["X-Access-Token"] = `Bearer ${accessToken}`

      processQueue(null, accessToken)

      return api(originalRequest)
    } catch (err) {
      processQueue(err, null)

      redirectToSignin()

      return Promise.reject(err)
    } finally {
      isRefreshing = false
    }
  }

  return Promise.reject(error)
}

const normalizeResponse = response => ({
  ...response,
  data: normalizeStoragePayload(response.data)
})

const farasodAuth = axios.create({
  baseURL: API_AUTH_URL
})
farasodAuth.interceptors.request.use(handleRequest)
farasodAuth.interceptors.response.use(
  normalizeResponse,
  error => handleError(error, farasodAuth)
)

const farasod = axios.create({
  baseURL: API_MAIN_URL
})
farasod.interceptors.request.use(handleRequest)
farasod.interceptors.response.use(
  normalizeResponse,
  error => handleError(error, farasod)
)

const farasodAnalytic = axios.create({
  baseURL: API_ANALYTIC_URL
})
farasodAnalytic.interceptors.request.use(handleRequest)
farasodAnalytic.interceptors.response.use(
  normalizeResponse,
  error => handleError(error, farasodAnalytic)
)

const farasodStorage = axios.create({
  baseURL: API_STORAGE_URL
})
farasodStorage.interceptors.request.use(handleRequest)
farasodStorage.interceptors.response.use(
  response => response,
  error => handleError(error, farasodStorage)
)

const farasodSubscribe = axios.create({
  baseURL: API_SUBSCRIBE_URL
})
farasodSubscribe.interceptors.request.use(handleRequest)
farasodSubscribe.interceptors.response.use(
  normalizeResponse,
  error => handleError(error, farasodSubscribe)
)

const farasodInstagram = axios.create({
  baseURL: "https://ig.mey-sam.com/"
})

export {
  farasod,
  farasodAuth,
  farasodStorage,
  farasodAnalytic,
  farasodSubscribe,
  farasodInstagram
}
